import React, { useState, useEffect } from 'react';

import UncommittedExpenditureCreateListRow from './UncommittedExpendituresCreateListRow';

import Button from 'CommonComponents/Button';

export default function CommittedExpendituresCreateList(props) {
    const [uncommittedExpenditures, setUncommittedExpenditures] = useState([]);
    const [committedExpenditures, setCommittedExpenditures] = useState([]);
    const [isLoading, setIsLoading] = useState(1);
    const [errors, setErrors] = useState('');

    useEffect(() => {
        fetchUncommittedExpenditures();
    }, []);

    const fetchUncommittedExpenditures = () => {
        setIsLoading(true);

        axios
            .get(props.uncommittedExpendituresDetailsUrl)
            .then((res) => {
                setUncommittedExpenditures(res.data);
                setIsLoading(false);
            })
            .catch((error) => {
                setUncommittedExpenditures([]);
                setIsLoading(false);
            });
    };

    const storeUncommittedExpenditures = (url = null) => {
        setIsLoading(true);

        axios
            .post(props.uncommittedExpendituresStoreUrl, { committedExpenditures })
            .then((res) => {
                setIsLoading(false);
                window.location.href = props.committedExpendituresCreateUrl.replace(
                    'UNCOMMITTED_EXPENDITURE_GROUP_ID',
                    res.data.uncommittedExpenditureGroup.id,
                );
            })
            .catch((error) => {
                setErrors('Please select at least 1 uncommitted expenditure to proceed');
                setIsLoading(false);
            });
    };

    return (
        <div className="row mt-3">
            <div className="col">
                <div className="card bg-white border-0 rounded-15px shadow py-2">
                    <div className="card-body">
                        <h6 className="text-blue font-weight-600 mb-2">Choose expenditures to commit</h6>
                        {errors != '' && (
                            <div className="alert alert-danger">
                                <ul>
                                    <li>{errors}</li>
                                </ul>
                            </div>
                        )}
                        <table className={'my-3 table  table-bordered no-footer'}>
                            <thead>
                                <tr>
                                    <th style={{ width: '10%' }}></th>
                                    <th style={{ width: '20%' }}>{$t('Name')}</th>
                                    <th style={{ width: '10%' }}>{$t('Cash')}</th>
                                    {props.vikEnabled && <th style={{ width: '10%' }}>{$t('VIK')}</th>}
                                    <th style={{ width: '10%' }}>{$t('Total')}</th>
                                    <th style={{ width: '10%' }}>{$t('Committed')}</th>
                                    <th style={{ width: '10%' }}>{$t('Uncommitted')}</th>
                                    <th style={{ width: '10%' }}>{$t('Risk')}</th>
                                    <th style={{ width: '10%' }}>{$t('Opportunities')}</th>
                                    <th style={{ width: '10%' }}>{$t('AFC')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading &&
                                    uncommittedExpenditures.length > 0 &&
                                    uncommittedExpenditures.map((uncommittedExpenditure) => {
                                        return (
                                            <UncommittedExpenditureCreateListRow
                                                key={uncommittedExpenditure.model + '_' + uncommittedExpenditure.id}
                                                uncommittedExpenditure={uncommittedExpenditure}
                                                uncommittedExpenditures={uncommittedExpenditures}
                                                committedExpenditures={committedExpenditures}
                                                setCommittedExpenditures={setCommittedExpenditures}
                                                vikEnabled={props.vikEnabled}
                                            />
                                        );
                                    })}
                                {!isLoading && uncommittedExpenditures.length == 0 && (
                                    <tr>
                                        <td colSpan={props.vikEnabled ? 9 : 8}>There are no uncommitted expenditures.</td>
                                    </tr>
                                )}
                                {isLoading && (
                                    <tr>
                                        <td colSpan={props.vikEnabled ? 9 : 8}>Loading...</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="d-flex justify-content-end p-3">
                            <Button variant="primary" onClick={storeUncommittedExpenditures} disabled={isLoading}>
                                Proceed to Commit Expenditures
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
